import { ElementType, LayoutElement } from '../types';
import { InstanceBatchResult } from '../workers/scene3dCompute';

/** Types rendered on the fab floor (position.z ≈ 0). */
export const FLOOR_3D_TYPES: ElementType[] = [
  'stocker',
  'oht-vehicle',
  'stb',
  'ohb',
  'lifter',
  'rectangle',
  'circle',
];

export const OVERHEAD_3D_TYPES: ElementType[] = ['overhead-rail', 'overhead-curve', 'cross-rail'];

/** Max canvas elevation treated as floor-mounted in 3D view. */
export const FLOOR_Z_THRESHOLD = 2;

export function isFloor3DType(type: ElementType): boolean {
  return FLOOR_3D_TYPES.includes(type);
}

export function isFloor3DElement(element: LayoutElement): boolean {
  if (OVERHEAD_3D_TYPES.includes(element.type)) return false;
  const z = element.position.z ?? 0;
  return z <= FLOOR_Z_THRESHOLD;
}

export function filterFloor3DView(
  elements: Record<string, LayoutElement>,
  elementOrder: string[]
): { elements: Record<string, LayoutElement>; elementOrder: string[] } {
  const filteredOrder: string[] = [];
  const filteredElements: Record<string, LayoutElement> = {};

  for (const id of elementOrder) {
    const el = elements[id];
    if (!el || !isFloor3DElement(el)) continue;
    filteredOrder.push(id);
    filteredElements[id] = el;
  }

  return { elements: filteredElements, elementOrder: filteredOrder };
}

export function filterFloorInstanceBatches(
  batches: InstanceBatchResult[] | null | undefined
): InstanceBatchResult[] | null {
  if (!batches?.length) return batches ?? null;
  return batches.filter((b) => b.elementType !== 'overhead-rail');
}
